export const translations = {
  en: {
    // Header
    company: 'Noble Law Firm',
    companyTagline: 'Legal Consultancy & Advisory',
    
    // Navigation
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    team: 'Our Team',
    contact: 'Contact',
    whatsapp: 'WhatsApp',
    
    // Hero Section
    heroTitle: 'Expert Lawyers in Iraq',
    heroSubtitle: 'Noble Law Firm - Legal Consultancy and Advisory in Erbil',
    heroDescription: 'Noble Law Company for Advocacy and Legal Consultancy – Civil and Professional, established in the City of Erbil in the Kurdistan Region – Iraq, in accordance with the Advocacy Law of the Kurdistan Region/Iraq No. (17) of 1999, as amended.',
    letsTalk: "Let's Talk",
    bookConsultation: 'Book Consultation',
    yearsExperience: '24+ Years',
    experienceLabel: 'of Legal Experience',
    
    // About Section
    aboutTitle: 'About Noble Law Company',
    aboutDescription: 'Noble Law Company is one of the leading companies in the field of advocacy in the City of Erbil, Kurdistan Region, Iraq. It provides legal services in all fields of law through a team of qualified and experienced advocates.',
    aboutSubtitle: 'Noble Law Company for Advocacy and Legal Consultancy – Civil and Professional, established in the City of Erbil in the Kurdistan Region – Iraq, in accordance with the Advocacy Law of the Kurdistan Region/Iraq No. (17) of 1999, as amended.',
    provenExpertise: 'Legal Services',
    provenExpertiseDesc: 'Entrust your legal matters, legal consultations, and claims to us. We are a legal team with (24) years of experience in legal practice, dedicated to resolving your legal disputes and challenges. Your success in your claims and legal matters is our responsibility.',
    yourSuccessOurMission: '',
    yourSuccessMissionDesc: '',
    
    // Services Section
    servicesTitle: 'Our Practice Areas',
    servicesSubtitle: 'Specialized legal solutions tailored to meet your personal and business needs',
    personalStatusCourts: 'Personal Status Courts',
    personalStatusCourtsDesc: 'Representing clients in all personal status cases, including divorce, judicial separation, alimony, child visitation, child recovery, and actions for the correction of personal status records.\nHandling marriage contract procedures and obtaining all Sharia-related official documents.',
    criminalCourts: 'Criminal Courts',
    criminalCourtsDesc: 'Representing clients in all criminal cases before the Investigation Courts, Misdemeanor Courts, Felony Courts, Juvenile Courts, and Military Courts.',
    civilCourts: 'Civil Courts',
    civilCourtsDesc: 'Representing clients in all civil cases, including matters relating to money and debts, property eviction, workers\' insurance, and all civil cases before the Civil Courts, Investment Courts, Commercial Courts, and Labour Courts.\nRepresenting clients in cases before the Personal Materials Courts and obtaining civil official documents.',
    administrativeCases: 'Administrative Cases',
    administrativeCasesDesc: 'Representing clients in administrative cases before the Administrative Court, the Kurdistan Region Employees Disciplinary Board, and the Kurdistan Region Shura Council.',
    enforcementJudgments: 'Enforcement of Court Judgments',
    enforcementJudgmentsDesc: 'Enforcement of judgments and decisions issued by all courts, and handling all procedures before the Enforcement Directorates, including the enforcement of promissory notes, bills of exchange, bank cheques, commercial instruments, and all other procedures carried out by the Enforcement Directorates.',
    contractsConsultancy: 'Contracts and Legal Consultancy',
    contractsConsultancyDesc: 'Preparing and drafting all legal contracts in various fields, and providing legal consultancy services to all institutions, organizations, companies, investors, and individuals.',
    companies: 'Companies',
    companiesDesc: 'Handling all matters relating to companies, including company incorporation, registration of trade names, trademarks, corporate taxation, company liquidation, and all matters related to company affairs.',
    bankingServices: 'Banking Services',
    bankingServicesDesc: 'Handling all banking-related transactions, including opening bank accounts, bank reconciliations, money transfers, and the purchase and sale of real estate through banks.',
    residencyForeigners: 'Residency and Foreigners\' Services',
    residencyForeignersDesc: 'Handling the issuance and renewal of residency permits for foreign nationals, obtaining entry visas for foreigners, and completing all procedures related to the employment and official transactions of foreign nationals before the competent governmental authorities.',
    realEstateRegistration: 'Real Estate Registration',
    realEstateRegistrationDesc: 'Handling all transactions related to the purchase and sale of land, real estate, and industrial facilities, as well as completing all related procedures and transactions, including tax formalities, before all competent authorities.',
    investment: 'Investment',
    investmentDesc: 'Handling investment transactions and completing all related procedures before the Investment Directorates and all competent institutions and authorities responsible for investment affairs.',
    taxServices: 'Tax Services',
    taxServicesDesc: 'Handling all matters relating to income tax, real estate tax, corporate and business taxes, and personal taxes.',
    viewServices: 'View Services',
    
    // Stats Section
    statsTitle: 'Trusted Law Firm in Erbil',
    statsDescription: 'We are a team of legal professionals ready to provide you with the best solutions for all your legal problems.',
    yearsInLaw: 'Years in Law',
    internationalTeam: 'International Team',
    casesWon: 'Cases Won',
    satisfiedClients: 'Satisfied Clients',
    partners: 'Partners',
    comprehensiveSupport: 'Comprehensive Support',
    
    // Team Section
    teamTitle: 'Our Experienced Lawyers',
    teamSubtitle: 'Meet the talented professionals behind our firm\'s success',
    seniorLegalConsultant: 'Consulting Advocate',
    seniorLegalConsultantFemale: 'Consulting Advocate',
    legalConsultant: 'Legal Consultant',
    partner: 'Partner',
    founderCEO: 'Founder / CEO',
    
    // Contact Form
    contactTitle: 'Get Free Consultation',
    contactStep1: 'Fill the Form',
    contactStep1Desc: 'Share contact information and brief case description',
    contactStep2: 'Submit Your Request',
    contactStep2Desc: 'We will review your case and respond immediately',
    contactStep3: 'Free Consultation*',
    contactStep3Desc: 'We will discuss your case, advise you and explain how we can help',
    contactStep4: 'Next Steps',
    contactStep4Desc: 'If you decide to proceed, we will guide you through the process with no hidden fees',
    contactDisclaimer: '*A free 15-minute evaluation session is available. In-depth legal strategy sessions are subject to consultation fees.',
    scheduleCall: 'Schedule a Call',
    selectService: 'Select Service',
    privacyNote: 'Your privacy matters to us, and your details will remain confidential',
    submit: 'Submit',
    
    // Contact Info
    mainAddress: 'Main Address',
    office: 'Office',
    location: 'Iraq, Erbil, Minara Choli Neighborhood',
    locationDetail: 'Opposite Zagros Bank & Qallat Bank',
    
    // Success Rates
    successRatesTitle: 'Our Success Results',
    successRatesSubtitle: 'Case success rates by category',
    cases: 'Cases',
    yearsOfExperience: '24+ Years',
    yearsOfExperienceLabel: 'Years of Experience',
    overallSuccessRate: '98%',
    overallSuccessRateLabel: 'Overall Success Rate',
    satisfiedClients: '1000+',
    satisfiedClientsLabel: 'Satisfied Clients',
    
    // Footer
    allRightsReserved: 'All rights reserved',
  },
  
  ar: {
    // Header
    company: 'مكتب Noble law للمحاماة',
    companyTagline: 'الاستشارات والخدمات القانونية',
    
    // Navigation
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'الخدمات',
    team: 'فريقنا',
    contact: 'اتصل بنا',
    whatsapp: 'واتساب',
    
    // Hero Section
    heroTitle: 'المحامون الخبراء في العراق',
    heroSubtitle: 'مكتب نوبل للمحاماة - استشارات قانونية في أربيل',
    heroDescription: 'شركة Noble Law  للمحاماة والاستشارات القانونية – المدنية والمهنية، مؤسسة في مدينة أربيل في إقليم كوردستان – العراق، وفقًا لقانون المحاماة في إقليم كوردستان/العراق رقم (17) لسنة (1999) المعدل.',
    letsTalk: 'لنتحدث',
    bookConsultation: 'احجز استشارة',
    yearsExperience: '24+ سنة',
    experienceLabel: 'من الخبرة القانونية',
    
    // About Section
    aboutTitle: 'عن شركة Noble Law',
    aboutDescription: 'تُعد شركة  Noble Law إحدى الشركات الرائدة في مجال المحاماة في مدينة أربيل – إقليم كوردستان، العراق، حيث تقدم الخدمات القانونية في جميع مجالات القانون من خلال فريق من المحامين الأكفاء وذوي الخبرة.',
    aboutSubtitle: 'شركة Noble Law  للمحاماة والاستشارات القانونية – المدنية والمهنية، مؤسسة في مدينة أربيل في إقليم كوردستان – العراق، وفقًا لقانون المحاماة في إقليم كوردستان/العراق رقم (17) لسنة (1999) المعدل.',
    provenExpertise: 'الخدمات القانونية',
    provenExpertiseDesc: 'أوكل إلينا أعمالك القانونية واستشاراتك القانونية ودعاواك، فنحن فريق قانوني يتمتع بخبرة تمتد إلى (24) عامًا في العمل القانوني، ونعمل على إيجاد الحلول لمشكلاتك ونزاعاتك القانونية. إن نجاحك في دعاواك وقضاياك القانونية هو مسؤوليتنا.',
    yourSuccessOurMission: '',
    yourSuccessMissionDesc: '',
    
    // Services Section
    servicesTitle: 'مجالات عملنا',
    servicesSubtitle: 'حلول قانونية متخصصة مصممة خصيصاً لتلبية احتياجاتك الشخصية والتجارية',
    personalStatusCourts: 'محاكم الأحوال الشخصية',
    personalStatusCourtsDesc: 'الترافع في جميع دعاوى الأحوال الشخصية، بما في ذلك: الطلاق، والتفريق، والنفقة، ورؤية الأطفال، واسترداد الأطفال، ودعاوى تصحيح قيود الأحوال الشخصية.\nإنجاز إجراءات عقد الزواج واستخراج جميع الوثائق الشرعية.',
    criminalCourts: 'المحاكم الجزائية',
    criminalCourtsDesc: 'الترافع في جميع الدعاوى الجزائية أمام محاكم التحقيق، ومحاكم الجنح، ومحاكم الجنايات، ومحاكم الأحداث، والمحاكم العسكرية.',
    civilCourts: 'المحاكم المدنية',
    civilCourtsDesc: 'الترافع في جميع الدعاوى المدنية، بما في ذلك: القضايا المتعلقة بالأموال والديون، وإخلاء العقارات، وتأمين العمال، وجميع الدعاوى المدنية أمام المحاكم المدنية، ومحاكم الاستثمار، والمحاكم التجارية، ومحاكم العمل.\nوالترافع في الدعاوى المنظورة أمام محاكم المواد الشخصية، واستخراج الوثائق المدنية.',
    administrativeCases: 'الدعاوى الإدارية',
    administrativeCasesDesc: 'الترافع في الدعاوى الإدارية أمام المحكمة الإدارية، وهيئة انضباط موظفي إقليم كوردستان، ومجلس شورى إقليم كوردستان.',
    enforcementJudgments: 'تنفيذ الأحكام القضائية',
    enforcementJudgmentsDesc: 'تنفيذ الأحكام والقرارات الصادرة عن المحاكم كافة، وإنجاز جميع معاملات مديريات التنفيذ، بما في ذلك تنفيذ الكمبيالات، والسفتجات، والشيكات المصرفية، وتنفيذ السندات التجارية، وجميع الإجراءات التي تقوم بها مديريات التنفيذ.',
    contractsConsultancy: 'العقود والاستشارات القانونية',
    contractsConsultancyDesc: 'إعداد وصياغة جميع العقود القانونية في مختلف المجالات، وتقديم الاستشارات القانونية إلى جميع المؤسسات والدوائر، والشركات، والمستثمرين، والمواطنين.',
    companies: 'الشركات',
    companiesDesc: 'إنجاز جميع الإجراءات المتعلقة بالشركات، بما في ذلك تأسيس الشركات، وتسجيل الأسماء التجارية، والعلامات التجارية، والضرائب الخاصة بالشركات، وتصفية الشركات، وجميع المسائل المتعلقة بأعمال الشركات.',
    bankingServices: 'الخدمات المصرفية',
    bankingServicesDesc: 'إنجاز جميع المعاملات المصرفية المتعلقة بالأعمال البنكية، بما في ذلك فتح الحسابات المصرفية، والتسويات المصرفية، والتحويلات المالية، وشراء وبيع العقارات عن طريق المصارف.',
    residencyForeigners: 'الإقامة ومعاملات الأجانب',
    residencyForeignersDesc: 'إنجاز معاملات إصدار إقامات الأجانب وتجديدها، وإصدار تأشيرات الدخول للأجانب، وإنجاز جميع الإجراءات المتعلقة بأعمال ومعاملات الأجانب لدى المؤسسات والدوائر الرسمية.',
    realEstateRegistration: 'تسجيل العقارات',
    realEstateRegistrationDesc: 'إنجاز معاملات شراء وبيع الأراضي والعقارات والمصانع، واستكمال جميع الإجراءات والمعاملات ذات الصلة، بما في ذلك الإجراءات الضريبية، لدى جميع المؤسسات والدوائر المختصة.',
    investment: 'الاستثمار',
    investmentDesc: 'إنجاز معاملات الاستثمار، واستكمال جميع الإجراءات والأعمال ذات الصلة أمام مديريات الاستثمار، وجميع المؤسسات والدوائر المختصة بشؤون الاستثمار.',
    taxServices: 'الضرائب',
    taxServicesDesc: 'إنجاز جميع المعاملات المتعلقة بضريبة الدخل، وضريبة العقارات، وضرائب الشركات والمنشآت، والضرائب الشخصية.',
    viewServices: 'عرض الخدمات',
    
    internationalLaw: 'القانون الدولي',
    internationalLawDesc: 'هەماهەنگی کردن لە کاری پارێزەرایەتی لە دەرەوەی وڵات.',
    viewServices: 'عرض الخدمات',
    
    // Stats Section
    statsTitle: 'مكتب محاماة موثوق به في أربيل',
    statsDescription: 'نحن فريق من المحترفين القانونيين المستعدين لتزويدك بأفضل الحلول لجميع مشاكلك القانونية.',
    yearsInLaw: 'سنوات في القانون',
    internationalTeam: 'فريق دولي',
    casesWon: 'من القضايا الفائزة',
    satisfiedClients: 'عملاء راضون',
    partners: 'شريك',
    comprehensiveSupport: 'دعم شامل',
    
    // Team Section
    teamTitle: 'محامونا المتمرسون',
    teamSubtitle: 'نقدم لكم المهنيين الموهوبين الذين يقفون وراء نجاح شركتنا',
    seniorLegalConsultant: 'المحامي المستشار',
    seniorLegalConsultantFemale: 'المحامية المستشارة',
    legalConsultant: 'مستشار قانوني',
    partner: 'شريك',
    founderCEO: 'المؤسس / المدير العام',
    
    // Contact Form
    contactTitle: 'احصل على استشارة مجانية',
    contactStep1: 'إملأ النموذج',
    contactStep1Desc: 'شارك معلومات الاتصال ووصفاً موجزاً للقضية',
    contactStep2: 'أرسل طلبك',
    contactStep2Desc: 'سوف نقوم بمراجعة حالتك ونرد عليك على الفور',
    contactStep3: 'استشارة مجانية*',
    contactStep3Desc: 'سنناقش حالتك ونقدم لك المشورة ونشرح لك كيف يمكننا مساعدتك',
    contactStep4: 'الخطوات التالية',
    contactStep4Desc: 'إذا قررت المتابعة، سنرشدك خلال العملية دون أي رسوم خفية',
    contactDisclaimer: '*تتوفر جلسة تقييم مجانية لمدة 15 دقيقة. تخضع جلسات الاستراتيجية القانونية المتعمقة لرسوم استشارة.',
    scheduleCall: 'جدولة مكالمة',
    selectService: 'اختر خدمة',
    privacyNote: 'خصوصيتك مهمة بالنسبة لنا، وتفاصيلك ستظل سرية',
    submit: 'إرسال',
    
    // Contact Info
    mainAddress: 'العنوان الرئيسي',
    office: 'المكتب',
    location: 'العراق، أربيل، حي مناره چولي',
    locationDetail: 'مقابل بنك زاكروس وبنك قلعت',
    
    // Success Rates
    successRatesTitle: 'نتائج نجاحنا',
    successRatesSubtitle: 'معدلات نجاح قضايانا حسب الفئات',
    cases: 'قضية',
    yearsOfExperience: 'سنة 24+',
    yearsOfExperienceLabel: 'خدمة قانونية',
    overallSuccessRate: '%98',
    overallSuccessRateLabel: 'نسبة النجاح في أعمالنا القانوني',
    satisfiedClients: '+1000',
    satisfiedClientsLabel: 'الالاف من الموكلين راضين',
    
    // Footer
    allRightsReserved: 'جميع الحقوق محفوظة',
  },
  
  ku: {
    // Header
    company: 'کۆمپانیای Noble law بۆ کاری پارێزەرایەتی',
    companyTagline: 'ڕاوێژکاری و خزمەتگوزاری یاسایی',
    
    // Navigation
    home: 'سەرەکی',
    about: 'دەربارەی ئێمە',
    services: 'خزمەتگوزارییەکان',
    team: 'تیمەکەمان',
    contact: 'پەیوەندی',
    whatsapp: 'واتساپ',
    
    // Hero Section
    heroTitle: 'پارێزەرانی شارەزای یاسایی لە عێراق  و هەرێمی کوردستان',
    heroSubtitle: '',
    heroDescription: 'کۆمپانیای Noble Law بۆ پارێزەرایەتی و ڕاوێژکاری یاسایی – مەدەنی پیشەیی بە پێ یاسای پارێزەرایەتی هەرێمی کوردستان/عێڕاق ژمارە (17) ی ساڵی (1999) ی هەموار کراو لە شاری هەولێر لە هەرێمی کوردستان – عێڕاق دا دامەزراوە.',
    letsTalk: 'با قسە بکەین',
    bookConsultation: 'کاتی ڕاوێژکاری بگرە',
    yearsExperience: '24+ ساڵ',
    experienceLabel: 'ئەزموونی یاسایی',
    
    // About Section
    aboutTitle: 'دەربارەی کۆمپانیای Noble Law',
    aboutDescription: 'کۆمپانیای Noble Law یەکێکە لە کۆمپانیا پێشەنگەکانی کاری پارێزەری لە شاری هەولێر- هەرێمی کوردستان، عێڕاق. کە لە ڕێگای تیمێک لە پارێزەرانی شارەزا و خاوەن ئەزموون خزمەتگوزاری یاسایی لە گشت بوارەکانی یاسادا پێشکەش دەکاتن.',
    aboutSubtitle: 'کۆمپانیای Noble Law بۆ پارێزەرایەتی و ڕاوێژکاری یاسایی – مەدەنی پیشەیی بە پێ یاسای پارێزەرایەتی هەرێمی کوردستان/عێڕاق ژمارە (17) ی ساڵی (1999) ی هەموار کراو لە شاری هەولێر لە هەرێمی کوردستان – عێڕاق دا دامەزراوە.',
    provenExpertise: 'خزمەتگوزاری یاسایی',
    provenExpertiseDesc: 'کارە یاساییەکان و ڕاوێژی یاسایی و داواکانت بە ئێمە بسپێرە، ئێمە وەکو تیمێکی یاسایی خاوەن ئەزمونی (24) ساڵ لە کارکردنی یاسایی چارەسەری کێشە و گرفتەکانت دەکەین، سەرکەوتنت لە داواکان و کێشە یاساییەکانت ئەرکی ئێمە.',
    yourSuccessOurMission: '',
    yourSuccessMissionDesc: '',
    
    // Services Section
    servicesTitle: 'بوارەکانی کارکردنمان',
    servicesSubtitle: 'کۆمپانیای نۆبڵ بە ئەزموونی (24) ساڵ کاری پارێزەرایەتی ئەنجام دەدات و بەردەوامە لە ئەنجام دانی ئەم کارانەی خوارەوە:-',
    personalStatusCourts: 'دادگای باری کەسی',
    personalStatusCourtsDesc: 'بینینی گشت داوایەکانی باری کەسی لەوانە: تەڵاق و جیابوونەوە و بژێوی و بینینی منداڵ و وەرگرتنەوەی منداڵ و داوایەکانی ڕاست کردنەوەی مامەڵە کەسییەکان.\nئەنجامدانی ڕێکارەکانی گرێبەستی هاوسەرگیری و دەرهێنانی گشت بەڵگەنامە شەرعییەکان.',
    criminalCourts: 'دادگا سزاییەکان',
    criminalCourtsDesc: 'بینینی گشت داوا سزاییەکان لە هەریەک لە دادگاکانی لێکۆڵینەوە و کەتن و تاوان و دادگای نەوجەوانان و دادگای سەربازی.',
    civilCourts: 'دادگای شارستانی',
    civilCourtsDesc: 'بینینی گشت داواکانی شارستانی لەوانە: بابەتی پارە و قەرز و چۆڵکردن و بیمەی کرێکاران و گشت بابەتە شارستانییەکان لە دادگاکانی شارستانی و وەبەرهێنان و بازرگانی و دادگای کار.\nوە داوایەکانی دادگای موادی کەسی و دەرهێنانی بەڵگەنامە شارستانییەکان.',
    administrativeCases: 'داوا کارگێڕییەکان',
    administrativeCasesDesc: 'بینینی داوا کارگێڕییەکان لە دادگای کارگێڕی و لە دەستەی بەرزەفتکاری فەرمانبەرانی هەرێم و ئەنجومەنی شورای هەرێمی کوردستان.',
    enforcementJudgments: 'جێبەجێ کردنی بڕیاری دادگاکان',
    enforcementJudgmentsDesc: 'جێبەجێ کردنی بڕیارە دەرچووەکانی دادگا لە گشت دادگاکاندا، ئەنجامدانی گشت مامەڵەکانی بەڕێوبەرایەتییەکانی جێبەجێ کردن، لەوانە ئەنجام دانی کۆمپیالە و سەفتەجە و چەکی بانکی و جێبەجێ کردنی قەواڵەکانی بازرگانی گشت ئەو ڕیکارانەی کە بەڕیوەبەرایەتی جێبەجێ کردن ئەنجامی دەدات.',
    contractsConsultancy: 'گرێبەست و ڕاوێژکاری یاسایی',
    contractsConsultancyDesc: 'ئەنجامدانی گشت گرێبەستە یاساییەکان لە گشت بوارەکاندا، وە پێشکەش کردنی ڕاوێژکاری یاسایی بۆ گشت دام و دەزگاکان و کۆمپانیاکان و وەبەرهێنان و هاوڵاتییان.',
    companies: 'کۆمپانیاکان',
    companiesDesc: 'ئەنجامدانی گشت کارەکانی کۆمپانیاکان لە بوارەکانی دامەزراندنی کۆمپانیاکان و ناوی بازرگانی و هێمای بازرگانی و باجی کۆمپانیاکان و تصفیەی کۆمپانیاکان و گشت بابەتە پەیوەندیدارەکان بەکارەکانی کۆمپانیاکانەوە.',
    bankingServices: 'بانک',
    bankingServicesDesc: 'ئەنجامدانی کارەکانی بانکی لە گشت بابەتە پەیوەندیدارەکان بە کاری بانکییەوە، کردنەوەی حسابی بانکی و ژمێڕکاری بانکی و حوالەی پارە و کڕین و فرۆشتنی موڵک لە ڕیگای بانکەوە.',
    residencyForeigners: 'نشینگە و مامەڵەی بیانییەکان',
    residencyForeignersDesc: 'ئەنجامدانی کارەکانی دەرهێنانی نشینگەی بیانییەکان و نوێ کردنەوە و ڤیزای بیانییەکان و ئەنجامدانی گشت کارە پەیوەندیدارەکان بە کار و مامەڵەی بیانییەکان لە دام و دەزگا فەرمییەکان.',
    realEstateRegistration: 'تۆمارکردنی خانووبەرە',
    realEstateRegistrationDesc: 'ئەنجامدانی مامەڵەکانی کڕین و فرۆشتنی زەوی و خانووبەرە و کارگە و ڕێکارەکان و گشت کارە پەیوەندیدارەکان و باج لە گشت دام و دەزگاکاندا.',
    investment: 'وەبەرهێنان',
    investmentDesc: 'ئەنجامدانی مامەڵەکانی وەبەرهێنان و ڕێکارەکان و کارە پەیوەندیدارەکان لە بەڕیوەبەرایەتییەکانی وەبەرهێنان و گشت دام و دەزگاکاندا پەیوەندیدار بە وەبەرهێنان.',
    taxServices: 'باجەکان',
    taxServicesDesc: 'ئەنجام دانی گشت کارەکانی تایبەت بە باجی دەرامەت و باجی خانووبەرە و باجی کۆمپانیا و کارگەکان و باجی کەسی.',
    viewServices: 'بینینی خزمەتگوزارییەکان',
    
    internationalLaw: 'یاسای نێودەوڵەتی',
    internationalLawDesc: 'هەماهەنگی کردن لە کاری پارێزەرایەتی لە دەرەوەی وڵات.',
    viewServices: 'بینینی خزمەتگوزارییەکان',
    
    // Stats Section
    statsTitle: 'کۆمپانیای پارێزەری متمانەپێکراو لە هەولێر',
    statsDescription: 'ئێمە تیمێکین لە پیشەییە یاساییەکان کە ئامادەین باشترین چارەسەرەکانت بۆ هەموو کێشە یاساییەکانت پێشکەش بکەین.',
    yearsInLaw: 'ساڵ لە یاسادا',
    internationalTeam: 'تیمی نێودەوڵەتی',
    casesWon: 'کەیسی بردەوە',
    satisfiedClients: 'کڕیاری ڕازی',
    partners: 'هاوبەش',
    comprehensiveSupport: 'پشتگیری تەواو',
    
    // Team Section
    teamTitle: 'پارێزەرە شارەزاکانمان',
    teamSubtitle: 'ئاشنابە بە پیشەییە بەهرەمەندەکان کە لە پشت سەرکەوتنی کۆمپانیاکەماندان',
    seniorLegalConsultant: 'پارێزەرى ڕاوێژکار',
    seniorLegalConsultantFemale: 'پارێزەرى ڕاوێژکار',
    legalConsultant: 'ڕاوێژکاری یاسایی',
    partner: 'هاوبەش',
    founderCEO: 'دامەزرێنەر / بەڕێوەبەری گشتی',
    
    // Contact Form
    contactTitle: 'ڕاوێژکاری بەخۆڕایی وەربگرە',
    contactStep1: 'فۆرمەکە پڕبکەرەوە',
    contactStep1Desc: 'زانیاری پەیوەندی و وەسفی کورتی کەیسەکە بڵاو بکەرەوە',
    contactStep2: 'داواکاریەکەت بنێرە',
    contactStep2Desc: 'کەیسەکەت پێداچوونەوە دەکەین و یەکسەر وەڵامت دەدەینەوە',
    contactStep3: 'ڕاوێژکاری بەخۆڕایی*',
    contactStep3Desc: 'کەیسەکەت گفتوگۆ دەکەین، ڕاوێژت پێ دەدەین و ڕوون دەکەینەوە چۆن دەتوانین یارمەتیت بدەین',
    contactStep4: 'هەنگاوەکانی دواتر',
    contactStep4Desc: 'ئەگەر بڕیارت دا بەردەوام بیت، ڕێنماییت دەکەین لە پرۆسەکەدا بەبێ هیچ کرێیەکی شاراوە',
    contactDisclaimer: '*کۆبوونەوەی هەڵسەنگاندنی بەخۆڕایی بۆ 15 خولەک بەردەستە. کۆبوونەوەکانی ستراتیژی یاسایی قووڵ کرێی ڕاوێژکاریان لەسەرە.',
    scheduleCall: 'پەیوەندی تۆمار بکە',
    selectService: 'خزمەتگوزاری هەڵبژێرە',
    privacyNote: 'تایبەتمەندیت بۆ ئێمە گرنگە، وردەکارییەکانت نهێنی دەمێننەوە',
    submit: 'ناردن',
    
    // Contact Info
    mainAddress: 'ناونیشانی سەرەکی',
    office: 'ئۆفیس',
    location: 'عێراق، هەولێر، گەڕەکی مناره‌ چولي',
    locationDetail: 'بەرامبەر بانکی زاگرۆس و بانکی قەڵات',
    
    // Success Rates
    successRatesTitle: 'ئەنجامەکانی سەرکەوتنمان',
    successRatesSubtitle: 'ڕێژەی سەرکەوتنی کەیس بەپێی پۆلەکان',
    cases: 'کەیس',
    yearsOfExperience: 'ساڵ 24+',
    yearsOfExperienceLabel: 'خزمەت لەبوارى یاسایی',
    overallSuccessRate: '%98',
    overallSuccessRateLabel: 'سەرکەوتووین لە کارە یاساییەکانمان',
    satisfiedClients: '+1000',
    satisfiedClientsLabel: 'زیاتر لە 1000 بریکارداری رەزامەند',
    
    // Footer
    allRightsReserved: 'هەموو مافێک پارێزراوە',
  },
};
